import { combineReducers } from "redux";

import errors from "./errors";

import auth from "./auth";
import account from "./accounts"
import login_history from "./login_history"
import app_server from "./appserver"
import app_server_log from "./appserverlog"
//
import blogs from './blogs';
import blogTag from './blogtag';
import blogCategory from './blogcategory';
// data for reports
import emotion_definitions from "./emotion_definitions";
import moods from "./moods";
import personality from "./personality";
import culture from "./culture";
import leadership from "./leadership";
import employee_report from "./employee_report";
import employee_category from "./employee_category";
import employee_permission from "./employee_permission";
import industry_benchmark from "./industry_benchmark";
import marketing_roi from "./marketing_roi"
import chat_gpt from "./chat_gpt";
import predictive_model from "./predictive_model";
// signup
import signupSteps from "./signup_steps";
// forms
import departments from "./departments"
import employees from "./employees"
import ambassadors from "./ambassadors"
import employee_roles from "./employee_roles"
import employee_log from "./employee_log";
import employee_record from "./employee_record";
import employee_record_list from "./employee_record_list";
import employee_record_value from "./employee_record_value";
import onboarding from "./onboarding"
import organizations from "./organizations"
import teams from "./teams"
import team_access from "./team_access"
import team_types from "./team_types"
import payments from "./payments"
import subscription from "./subscription"
import presentation_report from "./presentation_report";
// debriefs
import debrief_response from "./debrief_response";
import debrief_schedule from "./debrief_schedule";
import debrief_token from "./debrief_token";
import debrief_summary from "./debrief_summary";
import debrief_analytics from "./debrief_analytics";
import report_template from "./report_template";
import recommendation_model_rating from "./recommendation_model_rating";
import recommendation_models from "./recommendation_models";
import schedule_template from "./schedule_template";
import debrief_pdf_report from "./debrief_pdf_report";
import report_micro_service from "./report_micro_service";
import staff_reports from './staff_reports';

// settings
import change_log from "./change_log";
import documentation from "./documentation";
import survey_standard from "./survey_standard";
import activity_log from "./activity_log";
import fileupload from "./fileupload";
import emailTemplate from "./emailTemplate";
import pdfTemplate from "./pdfTemplate";
import surveystructure from "./surveystructure";
import surveystructurecompliance from "./surveystructurecompliance";
import surveyquestion from "./surveyquestion";
import signuptoken from "./signuptoken";
import surveytoken from "./surveytoken";
import surveyresponse from "./surveyresponse";
import surveyschedule from "./surveyschedule";
import surveyschedulefrequency from "./surveyschedulefrequency";
import surveycompliance from "./surveycompliance";
import leadersinschedule from "./leadersinschedule";
import leadersurveyparticipants from "./leadersurveyparticipants";
import teamsinschedule from "./teamsinschedule";
import personalityteams from "./personalityteams";
import personalityparticipants from "./personalityparticipants";
import validateEmail from "./validateEmail";
import emaildeliverystatus from "./emaildeliverystatus";
import surveysettinglist from "./surveysettinglist";
import applisturl from "./applisturl";
import web_api_credential from "./web_api_credential"
import web_api_log from "./web_api_log"
// product
import product from "./product";
import product_group from "./product_group";
import product_price from "./product_price";
import product_package from "./product_package";
import prod_org_contract from "./prod_org_contract";
import prod_dev_doc from "./prod_dev_doc";

import survey_ai_log from "./survey_ai_log";

import task_template from "./task_template";
import task_template_user_response from "./task_template_user_response";
import task_template_user_task from "./task_template_user_task";
import task_template_user_request from "./task_template_user_request";
//
import webimages from "./webimages";
// amabsaasdor switch
import selectedOrg from "./selectedOrg";
//Temp
import white_label from './white_label'
//Audit
import audit from './audit'
import admin_default from './admin_default'
// GPT
import gpt_summary from "./gpt_summary"
import gpt_model_main from "./gpt_model_main"
import gpt_response_main from "./gpt_response_main"
import gpt_response_score from "./gpt_response_score"
import gpt_members from "./gpt_members"
import gpt_web_chat from "./gpt_web_chat"
import gpt_recommendation from "./gpt_recommendation"
import gpt_recommendation_log from "./gpt_recommendation_log"
import gpt_web_chat_process from "./gpt_web_chat_process"
// v3 apps
import tag_type from './tag_types';
import report_dimension from './report_dimensions';
import question_bank from './question_banks';
import organization_category_tag from './organization_category_tags';
// import employee_category_tag from './employee_category_tags';
import survey_template_question from './survey_template_questions';
import survey_template_question_item from './survey_template_question_items';
import survey_scheduler from './survey_schedulers';
import survey_event from './survey_events';
import survey_invite from './survey_invites';
import survey_event_response from './survey_event_responses';
import groups from './groups';

import action_actions from "./action_actions";
import action_dashboard from "./action_dashboard";
import action_events from "./action_events";
import action_campaign from "./action_campaign";
import action_updates from "./action_updates";
import action_analytics from "./action_analytics";
import action_assignee from "./action_assignee";
import action_phase_transition from "./action_phase_transition";
import action_report from "./action_report";
import action_reminders from "./action_reminders";
import action_template from "./action_template";
import action_email from "./action_email";
import action_planning_status from "./action_planning_status";

import slackTasksReducer from './slackTasksReducer';
import LLMLogReducer from "./llm_log";
import public_upload from "./public_upload";
// import survey_settings from "./survey_settings";


export default combineReducers({
  errors,
  auth,
  account,
  login_history,
  change_log,
  activity_log,
  selectedOrg,
  culture,
  blogs,
  blogTag,
  blogCategory,
  marketing_roi,
  emotion_definitions,
  moods,
  leadership,
  personality,
  departments,
  employees,
  ambassadors,
  employee_report,
  employee_roles,
  employee_log,
  employee_record,
  employee_record_list,
  employee_record_value,
  employee_category,
  employee_permission,
  slack_tasks: slackTasksReducer,
  organizations,
  industry_benchmark,
  onboarding,
  tag_type,
  report_dimension,
  question_bank,
  organization_category_tag,
  action_actions,
  action_dashboard,
  action_events,
  action_campaign,
  action_updates,
  action_analytics,
  action_assignee,
  action_phase_transition,
  action_reminders,
  action_template,
  action_report,
  action_email,
  action_planning_status,
  // employee_category_tag,
  survey_template_question,
  survey_template_question_item,
  survey_scheduler,
  survey_event,
  survey_invite,
  survey_event_response,
  debrief_response,
  presentation_report,
  debrief_schedule,
  debrief_token,
  debrief_summary,
  debrief_analytics,
  debrief_pdf_report,
  predictive_model,
  llm_log: LLMLogReducer,
  chat_gpt,
  teams,
  team_access,
  fileupload,
  emailTemplate,
  pdfTemplate,
  product,
  product_group,
  product_price,
  product_package,
  prod_org_contract,
  prod_dev_doc,
  subscription,
  gpt_summary,
  gpt_model_main,
  gpt_response_main,
  gpt_response_score,
  gpt_members,
  gpt_web_chat,
  gpt_web_chat_process,
  gpt_recommendation,
  gpt_recommendation_log,
  survey_ai_log,
  task_template,
  task_template_user_response,
  task_template_user_task,
  task_template_user_request,
  report_template,
  recommendation_model_rating,
  recommendation_models,
  schedule_template,
  payments,
  signupSteps,
  surveyquestion,
  surveyschedule,
  surveystructure,
  surveystructurecompliance,
  surveyschedulefrequency,
  surveycompliance,
  surveysettinglist,
  survey_standard,
  personalityteams,
  personalityparticipants,
  leadersinschedule,
  leadersurveyparticipants,
  teamsinschedule,
  report_micro_service,
  staff_reports,
  signuptoken,
  surveytoken,
  surveyresponse,
  team_types,
  validateEmail,
  emaildeliverystatus,
  applisturl,
  app_server,
  app_server_log,
  web_api_credential,
  web_api_log,
  white_label,
  audit,
  webimages,
  admin_default,
  documentation,
  groups,
  public_upload,
});
